import React from "react";
import {
  BarGauge,
  Label,
  Legend,
} from "devextreme-react/bar-gauge";

const format = {
  type: "fixedPoint",
  precision: 1,
};


const palette = ["#17a2b8", "#6ab41b"]

const ProgressIndicator = (props) => {
  let { data, labels, mini } = props;
  return (
    <BarGauge
      startValue={0}
      endValue={100}
      values={data}
      defaultValues={[0, 0]}
      geometry={{ startAngle: 210, endAngle: -30 }}
      relativeInnerRadius={10}
      style={{
        marginTop: "-30px",
        marginBottom: "-30px",
      }}
      palette={["#17a2b8", "#6ab41b"]}
    >


    <Label
        visible={true}                                // muestra la etiqueta :contentReference[oaicite:0]{index=0}
        format={format}                               // formato numérico :contentReference[oaicite:1]{index=1}
        customizeText={({ valueText }) =>            // usa valueText (ya formateado) y concatena “%” :contentReference[oaicite:2]{index=2}
          `${valueText}%`
        }
        indent={8}                                    // separa la etiqueta del arco :contentReference[oaicite:3]{index=3}
        position="outside"                            // fuera del arco :contentReference[oaicite:4]{index=4}
        connectorColor={palette[1]}                   // color del conector :contentReference[oaicite:5]{index=5}
        connectorWidth={1}
                                    // grosor del conector :contentReference[oaicite:6]{index=6}
        font={{ weight: "bold", size: mini ? 10 : 12 }}// estilo de la fuente :contentReference[oaicite:7]{index=7}
      />

          <Legend
        visible={true}
        verticalAlignment="bottom"
        horizontalAlignment="center"
        itemTextPosition="bottom"
          customizeText={(arg) => {
          //   return `${labels[arg.item.index]}: ${arg.text}%`;
          return `${labels[arg.item.index]} %`;
        }}
        markerSize={8}
        font={{ size: mini ? 10 : 12 }}
        margin={{ top: 8, bottom: 0 }}
      />

    </BarGauge>
  );
};

export default ProgressIndicator;
